import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { checkPermission } from "../redux/api/PermissionManager";
function useDebounce(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debounced;
}
const ReferEarn = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const { paginationData, setpaginationData } = useGlobalContext();
  const path = location.pathname?.replace("/", "");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);

  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [popup, setPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(false);
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [fromDate, setFormDate] = useState();
  const [toDate, setToDate] = useState();
  const [owners, setOwners] = useState([]);

  // const viewReferList = async () => {
  //   const res = await get(URLS.REFERLIST);
  //   console.log("view property", res);
  //   if (res?.status === "success") {
  //     setOwners(res?.data);
  //   }
  // };

  const viewReferList = async ({
    selectedFilter, // e.g. { from_date, to_date } or other filter options
    debouncedSearch, // search string
    page = 1,
    page_size = 10,
  }) => {
    // Construct the URL with relevant query params
    const params = new URLSearchParams();
    if (debouncedSearch) params.append("search", debouncedSearch);
    if (selectedFilter?.from_date && selectedFilter?.to_date) {
      params.append("from_date", selectedFilter.from_date);
      params.append("to_date", selectedFilter.to_date);
    }

    params.append("page", page);
    params.append("page_size", page_size);

    const url = `${URLS.REFERLIST}?${params.toString()}`;

    const res = await get(url);
    console.log("view property", res);
    if (res?.status === "success") {
      setPagination({ current_page: page, last_page: res?.total_pages });

      setOwners(res?.data);
    }
  };

  const [selectedFilter, setSelectedFilter] = useState({
    from_date: "",
    to_date: "",
    search: "",
  });
  const handleChangeFilter = useCallback((name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
    setPage(1); // Reset to first page on filter change
  }, []);
  const debouncedSearch = useDebounce(selectedFilter.search, 350);

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "User",
        accessor: "user_name",
        Cell: ({ value, row }) => {
          const items = row.original;
          console.log("DJksaDJAS", items);
          return (
            <div>
              <p style={{ color: "#AE55F5", fontWeight: "600", width: "50px" }}>
                {value}
              </p>
              <p style={{ color: "#AE55F5", fontWeight: "600", width: "50px" }}>
                {items?.user_code}
              </p>
            </div>
          );
        },
      },
      {
        Header: " No Of Referral",
        accessor: "no_of_referrals",
        Cell: ({ value, row }) => {
          return <p style={{ textAlign: "left", paddingLeft: 50 }}>{value}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Total Earn Amount",
        accessor: "total_earn",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/referearnview", {
                    state: { type: "view", userId: row?.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-REFER_&_EARN") ? [...d, action] : d;
  }, [page]);
  useEffect(() => {
    viewReferList({ selectedFilter, debouncedSearch, page });
  }, []);

  useEffect(() => {
    // define async function inside effect
    const fetchReferralList = async () => {
      await viewReferList({
        selectedFilter: {
          from_date: selectedFilter?.from_date,
          to_date: selectedFilter?.to_date,
        },
        debouncedSearch,
        page: page,
        // page_size: 2,
      });
    };

    fetchReferralList();
  }, [selectedFilter, debouncedSearch]);

  console.log("owners_owners", owners, selectedFilter, debouncedSearch);
  return (
    <div>
      <Topbar header={"Refer & Earn"} />
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{owners.length}
      </h2>
      <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
        {/* <DateRange
          setFromDate={(date) => handleChangeFilter("from_date", date)}
          setToDate={(date) => handleChangeFilter("to_date", date)}
        /> */}
        <div className="search-input">
          <input
            //  onChange={(e) => (adminList(1, e.target.value))}
            type="text"
            placeholder=" Code,Name"
            value={selectedFilter.search}
            onChange={(e) => handleChangeFilter("search", e.target.value)}
            style={{ border: "none", width: "150px" }}
          />
          <img src={Search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
    </div>
  );
};

export default ReferEarn;
